// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app_markdown_display[data-v-2b016c38]{background:var(--c-component-background-color,var(--c-default-component-background-color));box-shadow:none;display:block;overflow-wrap:break-word;overflow:hidden;resize:none!important;width:100%}.markdown__body[data-v-2b016c38]{width:100%}", ""]);
// Exports
module.exports = exports;
